// extracted by mini-css-extract-plugin
export var container = "_bg-1";
export var cornerButtonContainer = "_bg-5";
export var disabled = "_bg-2";
export var fileContainer = "_bg-4";
export var hiddenInput = "_bg-3";
export var widthContainer = "_bg-0";